var map = {
	"./boost_activate.wav": 6661,
	"./boost_ball.mp3": 4601,
	"./boost_ball.wav": 8037,
	"./boost_off.wav": 81,
	"./boost_on.wav": 9597,
	"./down_one_ball.wav": 6241,
	"./party_time.mp3": 6090,
	"./red_ball_hit.mp3": 891,
	"./vanish_version1.wav": 4427,
	"./vanish_version2.wav": 4516,
	"./vanish_version3.wav": 8701,
	"./vanish_version4.wav": 5214,
	"./vanish_version5.wav": 3623,
	"./wall_hit.wav": 7412,
	"./wand_whoosh_version1.wav": 4645,
	"./wand_whoosh_version2.wav": 8154,
	"./wand_whoosh_version3.wav": 5347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2382;